import type { ActionName } from 'state/common-form/infos/infos.model';

import type { QuoteActionsUiStateMap } from './quoteActions.model';

export function getActiveQuoteActionFor(
  state: QuoteActionsUiStateMap,
  tabId: string,
  actionName: ActionName,
): ActionName {
  switch (actionName) {
    case 'TradableQuote':
    case 'AdvancedTradableQuote':
      return getActiveQuoteActionForTradableQuoteButton(state, tabId);

    case 'ExecOnly':
    case 'AdvancedExecOnly':
      return getActiveQuoteActionForExecOnlyButton(state, tabId);

    case 'IndicativeQuote':
    case 'AdvancedIndicativeQuote':
      return getActiveQuoteActionForIndicativeQuoteButton(state, tabId);

    case 'ExecutableQuote':
    case 'AdvancedExecutableQuote':
      return getActiveQuoteActionForExecutableQuoteButton(state, tabId);

    default:
      return actionName;
  }
}

function getActiveQuoteActionForTradableQuoteButton(state: QuoteActionsUiStateMap, tabId: string): ActionName {
  const quoteActionsUiState = state && state[tabId];

  if (!Array.isArray(quoteActionsUiState?.selectedActions)) {
    return 'TradableQuote';
  }

  const selected = quoteActionsUiState.selectedActions.find(
    a => a === 'TradableQuote' || a === 'AdvancedTradableQuote',
  );
  return selected ?? 'TradableQuote';
}

function getActiveQuoteActionForExecOnlyButton(state: QuoteActionsUiStateMap, tabId: string): ActionName {
  const quoteActionsUiState = state && state[tabId];

  if (!Array.isArray(quoteActionsUiState?.selectedActions)) {
    return 'ExecOnly';
  }

  const selected = quoteActionsUiState.selectedActions.find(a => a === 'ExecOnly' || a === 'AdvancedExecOnly');
  return selected ?? 'ExecOnly';
}

function getActiveQuoteActionForIndicativeQuoteButton(state: QuoteActionsUiStateMap, tabId: string): ActionName {
  const quoteActionsUiState = state && state[tabId];

  if (!Array.isArray(quoteActionsUiState?.selectedActions)) {
    return 'IndicativeQuote';
  }

  const selected = quoteActionsUiState.selectedActions.find(
    a => a === 'IndicativeQuote' || a === 'AdvancedIndicativeQuote',
  );
  return selected ?? 'IndicativeQuote';
}

function getActiveQuoteActionForExecutableQuoteButton(state: QuoteActionsUiStateMap, tabId: string): ActionName {
  const quoteActionsUiState = state && state[tabId];

  if (!Array.isArray(quoteActionsUiState?.selectedActions)) {
    return 'ExecutableQuote';
  }

  const selected = quoteActionsUiState.selectedActions.find(
    a => a === 'ExecutableQuote' || a === 'AdvancedExecutableQuote',
  );
  return selected ?? 'ExecutableQuote';
}
